import React, { useEffect } from "react";
import MapChart from "common/components/MapChart/MapChart";
import { useMapChart } from "hooks/chart/UseMapChart";
import topology from "utils/maps/worldTopology.json";

const MapChartGrapher = ({ data }) => {
    const {
        options: optionsMapChart,
        updateDataAndVisibility,
        showLoading,
        hideLoading,
        hasData,
    } = useMapChart();

    useEffect(() => {
        if (!data) return;

        showLoading();

        setTimeout(() => {
            updateDataAndVisibility(data.data || []);
            hideLoading();
        }, 100);
    }, [data]);

    return <MapChart options={optionsMapChart} hasData={hasData} />;
};

export default MapChartGrapher;
